
import { useEffect, useState } from "react"
import Tooltip from "@material-ui/core/Tooltip";
import { insertInvoice, updateReservedFactorForMoadian } from "../../../../../api/requestAxios/invoice"
import { ErrorSvg } from "../../../../../assets/images/svg/errorSvg"
import { ErrorToast, InfoToast } from "../../../../../shared"
import CityProvince from "./cityProvince"
import { makeStyles } from '@material-ui/core/styles';
import checkNationalCode from "../../../../../functions/extensions/checkNationalCode";
import { getProvince } from "../../../../../api/requestAxios/userInfo";
import CustomValuesHook from "../../../../../functions/myHooks/CustomValuesHook";
import constants from "../../../../../constants/constants";
import { isCorrectEmail, isCorrectPhone, isCorrectPostalCodeRegex, isNumber } from "../../../../../functions/extensions/regexModel";
import ModalLoaderReserve from "./modalLoaderReserve";


const ModalContent = ({
    handleInfoForm,
    infoForm,
    fromPage,
    infoModel,
    setInfoModel,
    createCityList,
    setShowModalInfo,
    reservedInAccepInvoice,
    reservedInPendInvoice,
    item,
    provLoading,
    getLoading
}) => {


    const useStyles = makeStyles({
        tooltip: {
            background: '#333',
            borderRadius: '20px ',
            color: '#FFF',
            padding: '8px 15px',
            fontSize: '14px'
        },
    });

    const [loading, setLoading] = useState(false)
    const [isUpdate, setIsUpdate] = useState(false)
    const classesToolTip = useStyles();






    const [validForm, handleValidForm] = CustomValuesHook({
        inputValidBuyerNameReservedOrReturned: true,
        inputValidNationalCodeReservedOrReturned: true,
        inputValidAddressReservedOrReturned: true,
        inputValidPhoneReservedOrReturned: true,
        inputValidResidencePostalCodeReservedOrReturned: true,
        inputValidCityReservedOrReturned: true,
        inputValidProvinceReservedOrReturned: true,
        inputValidEmailReservedOrReturned: true,
        inputValidTotalAmountReservedOrReturned: true,
        inputValidDescriptionReservedOrReturned: true,
        inputValidFactorIssueType: true,

    })


    useEffect(() => {
        checkValidate()
    }, [infoModel])


    const checkValidtionNationalId = (NationalCodeReservedOrReturned) => {
        if (NationalCodeReservedOrReturned === '' || NationalCodeReservedOrReturned === null) return false
        else if (isNumber(infoModel?.NationalCodeReservedOrReturned) && infoModel?.NationalCodeReservedOrReturned.length === 11) return true
        else return false
    }


    const checkValidate = (e) => {
        let temp = {}
        infoModel?.PhoneReservedOrReturned ? temp.inputValidPhoneReservedOrReturned = isCorrectPhone(infoModel?.PhoneReservedOrReturned) : temp.inputValidPhoneReservedOrReturned = true
        infoModel?.ResidencePostalCodeReservedOrReturned ? temp.inputValidResidencePostalCodeReservedOrReturned = isCorrectPostalCodeRegex(infoModel?.ResidencePostalCodeReservedOrReturned) : temp.inputValidResidencePostalCodeReservedOrReturned = true
        infoModel?.EmailReservedOrReturned ? temp.inputValidEmailReservedOrReturned = isCorrectEmail(infoModel?.EmailReservedOrReturned) : temp.inputValidEmailReservedOrReturned = true

        temp.inputValidDescriptionReservedOrReturned = infoModel?.DescriptionReservedOrReturned ? true : false

        if (fromPage === 'reserved') temp.inputValidFactorIssueType = infoModel?.FactorIssueType ? true : false

        if (infoModel?.FactorIssueType === 2) {
            //حقوقی
            temp.inputValidNationalCodeReservedOrReturned = checkValidtionNationalId(infoModel?.NationalCodeReservedOrReturned)
            temp.inputValidTotalAmountReservedOrReturned = infoModel?.TotalAmountReservedOrReturned ? isNumber(infoModel?.TotalAmountReservedOrReturned) : false
            temp.inputValidResidencePostalCodeReservedOrReturned = isCorrectPostalCodeRegex(infoModel?.ResidencePostalCodeReservedOrReturned)
            temp.inputValidAddressReservedOrReturned = infoModel?.AddressReservedOrReturned ? true : false
            temp.inputValidBuyerNameReservedOrReturned = infoModel?.BuyerNameReservedOrReturned ? true : false
            temp.inputValidCityReservedOrReturned = infoModel?.CityIdReservedOrReturned ? true : false

        }
        else if (infoModel?.FactorIssueType === 1) {
            //حقیقی
            temp.inputValidNationalCodeReservedOrReturned = infoModel?.NationalCodeReservedOrReturned ? checkNationalCode(infoModel?.NationalCodeReservedOrReturned) : false
            temp.inputValidTotalAmountReservedOrReturned = infoModel?.TotalAmountReservedOrReturned ? isNumber(infoModel?.TotalAmountReservedOrReturned) : false
        }
        else {
            if (infoModel?.NationalCodeReservedOrReturned === '' || infoModel?.NationalCodeReservedOrReturned === null) temp.inputValidNationalCodeReservedOrReturned = true
            else if (infoModel?.NationalCodeReservedOrReturned.length === 10 && checkNationalCode(infoModel?.NationalCodeReservedOrReturned)) temp.inputValidNationalCodeReservedOrReturned = true
            else if (infoModel?.NationalCodeReservedOrReturned.length === 11 && isNumber(infoModel?.NationalCodeReservedOrReturned)) temp.inputValidNationalCodeReservedOrReturned = true
            else temp.inputValidNationalCodeReservedOrReturned = false
        }
        handleValidForm(temp)
    }



    const update = async () => {
        setLoading(true)
        try {
            const res = await updateReservedFactorForMoadian(infoModel)
            setLoading(false)
            setShowModalInfo(false)
            if (res.data?.IsSuccess) {
                InfoToast('اطلاعات با موفقیت به روز شد')
            }
            else {
                ErrorToast(res?.data?.Description)
            }
        }
        catch {
            setLoading(true)
            setShowModalInfo(false)
            ErrorToast('سرور با مشکل مواجه است')
        }

    }



    const handleForm = (e) => {
        e.preventDefault()


        if (fromPage !== 'newReserve' && fromPage !== 'pending') {
            update()
        }
        else if (fromPage === 'newReserve') {
            setShowModalInfo(false)
            reservedInAccepInvoice(infoModel)
        }
        else if (fromPage === 'pending') {
            setShowModalInfo(false)
            reservedInPendInvoice(infoModel, infoForm?.isUpdate ? item?.idTable : undefined, infoForm?.isUpdate)
        }


    }

    const validateForm = () => {
        if (validForm.inputValidBuyerNameReservedOrReturned &&
            validForm.inputValidNationalCodeReservedOrReturned &&
            validForm.inputValidAddressReservedOrReturned &&
            validForm.inputValidPhoneReservedOrReturned &&
            validForm.inputValidResidencePostalCodeReservedOrReturned &&
            validForm.inputValidCityReservedOrReturned &&
            validForm.inputValidProvinceReservedOrReturned &&
            validForm.inputValidEmailReservedOrReturned &&
            validForm.inputValidTotalAmountReservedOrReturned &&
            validForm.inputValidDescriptionReservedOrReturned &&
            validForm.inputValidFactorIssueType
        ) {
            return true
        }
        else {
            return false
        }
    }



    const isDisabled = () => {
        return (item?.MoadianStatus === 'SUCCESS' || item?.MoadianStatus === 'PENDING' || item?.MoadianStatus === 'IN_PROGRESS')
    }


    return (
        <>
            {(getLoading || provLoading) ? <ModalLoaderReserve /> : <form className="reserve-info" onSubmit={(e) => { handleForm(e) }}>
                <div className="d-flex justify-content-between reason-reserve">
                    <div className="d-flex justify-content-between">
                        <div className="d-flex justify-content-start align-items-center">
                            <label>شرح رزرو فاکتور</label>
                            {!infoModel?.DescriptionReservedOrReturned && <span className="required">*</span>}
                        </div>
                        <input
                            type="text"
                            onChange={(e) => { setInfoModel({ DescriptionReservedOrReturned: e.target.value }) }}
                            value={infoModel?.DescriptionReservedOrReturned}
                            disabled={isDisabled()}
                        />
                    </div>
                </div>
                {<div className="row d-flex justify-content-between type-invoice">
                    <div className="d-flex justify-content-between">
                        <div className="d-flex justify-content-start align-items-center">
                            <label>نوع فاکتور</label>
                            {fromPage === 'reserved' && !infoModel?.FactorIssueType && <span className="required">*</span>}
                        </div>
                        <div className="error-wrapper type-invoice-error">
                            <select value={infoModel?.FactorIssueType?.toString()}
                                onChange={(e) => { setInfoModel({ FactorIssueType: parseInt(e.target.value) }) }}
                            >
                                <option value=""> انتخاب کنید</option>
                                {fromPage !== 'reserved' && <option value="0">نامشخص</option>}
                                <option value="1">حقیقی</option>
                                <option value="2">حقوقی</option>
                            </select>
                        </div>
                    </div>
                </div>}
                <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column justify-content-between input-lbl-wrapper">
                        <div className="d-flex justify-content-start align-items-center">
                            <label>نام و نام خانوادگی/شرکت</label>
                            {infoModel?.FactorIssueType === 2 && !infoModel?.BuyerNameReservedOrReturned && <span className="required">*</span>}
                        </div>

                        <input
                            type="text"
                            onChange={(e) => { setInfoModel({ BuyerNameReservedOrReturned: e.target.value }) }}
                            value={infoModel?.BuyerNameReservedOrReturned}
                            disabled={isDisabled()}
                        />

                    </div>
                    <div className="d-flex flex-column justify-content-between  input-lbl-wrapper">
                        <div className="d-flex justify-content-start align-items-center">
                            <label>کدملی/شناسه‌ی ملی</label>
                            {!infoModel?.NationalCodeReservedOrReturned && infoModel?.FactorIssueType !== null && infoModel?.FactorIssueType !== '' && <span className="required">*</span>}
                        </div>
                        <div className="error-wrapper">
                            <input
                                type="text"
                                onChange={(e) => { setInfoModel({ NationalCodeReservedOrReturned: e.target.value }) }}
                                value={infoModel?.NationalCodeReservedOrReturned}
                                disabled={isDisabled()}
                            />
                            {infoModel?.NationalCodeReservedOrReturned && !validForm?.inputValidNationalCodeReservedOrReturned && <Tooltip classes={classesToolTip} title={'کد ملی/ شناسه ی  را به صورت صحیح وارد کنید.'} >
                                <span className='error-input'><ErrorSvg /></span>
                            </Tooltip>}
                        </div>

                    </div>
                </div>
                <div className="d-flex justify-content-between">
                    <div className="d-flex  flex-column justify-content-between  input-lbl-wrapper">
                        <label>ایمیل</label>
                        <div className="error-wrapper">
                            <input
                                autoComplete="xtr"
                                type="text"
                                onChange={(e) => { setInfoModel({ EmailReservedOrReturned: e.target.value }) }}
                                value={infoModel?.EmailReservedOrReturned}
                                disabled={isDisabled()}
                            />
                            {!validForm?.inputValidEmailReservedOrReturned && <Tooltip classes={classesToolTip} title={'ایمیل  را به صورت صحیح وارد کنید.'} >
                                <span className='error-input'><ErrorSvg /></span>
                            </Tooltip>}
                        </div>

                    </div>
                    <div className="d-flex  flex-column justify-content-between  input-lbl-wrapper">
                        <label>شماره تلفن</label>
                        <div className="error-wrapper">
                            <input
                                type="text"
                                onChange={(e) => { setInfoModel({ PhoneReservedOrReturned: e.target.value }) }}
                                value={infoModel?.PhoneReservedOrReturned}
                                disabled={isDisabled()}
                            />
                            {!validForm?.inputValidPhoneReservedOrReturned && <Tooltip classes={classesToolTip} title={' شماره تلفن را به صورت صحیح وارد کنید.'} >
                                <span className='error-input'><ErrorSvg /></span>
                            </Tooltip>}
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-between">
                    <CityProvince
                        infoForm={infoForm}
                        setInfoModel={setInfoModel}
                        fromPage={fromPage}
                        infoModel={infoModel}
                        handleInfoForm={handleInfoForm}
                        createCityList={createCityList}
                        handleValidForm={handleValidForm}
                        validForm={validForm}
                    />
                </div>
                <div className="d-flex justify-content-between">
                    <div className="d-flex  flex-column justify-content-between  input-lbl-wrapper">
                        <div className="d-flex justify-content-start align-items-center">
                            <label>آدرس</label>
                            {infoModel?.FactorIssueType === 2 && !infoModel?.AddressReservedOrReturned && <span className="required">*</span>}
                        </div>
                        <textarea
                            type="text"
                            onChange={(e) => { setInfoModel({ AddressReservedOrReturned: e.target.value }) }}
                            value={infoModel?.AddressReservedOrReturned}
                            disabled={isDisabled()}
                        />

                    </div>
                    <div className="d-flex  flex-column justify-content-start  input-lbl-wrapper">
                        <div className="d-flex justify-content-start align-items-center">
                            <label>کدپستی</label>
                            {infoModel?.FactorIssueType === 2 && !infoModel?.ResidencePostalCodeReservedOrReturned && <span className="required">*</span>}
                        </div>
                        <div className="error-wrapper">
                            <input
                                type="text"
                                onChange={(e) => { setInfoModel({ ResidencePostalCodeReservedOrReturned: e.target.value }) }}
                                value={infoModel?.ResidencePostalCodeReservedOrReturned}
                                disabled={isDisabled()}
                            />
                            {infoModel?.ResidencePostalCodeReservedOrReturned && !validForm?.inputValidResidencePostalCodeReservedOrReturned && <Tooltip classes={classesToolTip} title={'کد پستی را به صورت صحیح وارد کنید.'} >
                                <span className='error-input'><ErrorSvg /></span>
                            </Tooltip>}
                        </div>

                        <div className="d-flex justify-content-start align-items-center">
                            <label>مبلغ</label>
                            {(infoModel?.FactorIssueType === 2 || infoModel?.FactorIssueType === 1) && !infoModel?.TotalAmountReservedOrReturned && <span className="required">*</span>}
                        </div>
                        <div className="error-wrapper">
                            <input
                                type="text"
                                onChange={(e) => { setInfoModel({ TotalAmountReservedOrReturned: e.target.value }) }}
                                value={infoModel?.TotalAmountReservedOrReturned}
                                disabled={isDisabled()}
                            />
                            {infoModel?.TotalAmountReservedOrReturned && !validForm?.inputValidTotalAmountReservedOrReturned && <Tooltip classes={classesToolTip} title={' مبلغ را به صورت صحیح وارد کنید.'} >
                                <span className='error-input'><ErrorSvg /></span>
                            </Tooltip>}
                        </div>




                    </div>
                </div>

                <div className="d-flex justify-content-end">
                    {!loading && <button
                        className="btn"
                        type="submit"
                        disabled={loading || !validateForm()}
                    >
                        ذخیره‌سازی
                    </button>}

                    {loading &&
                        <div className="d-flex justify-content-center loader-save">
                            <div className="spinner-border " role="status" aria-hidden="true"></div>
                        </div>
                    }
                </div>
            </form >}
        </>
    )

}

export default ModalContent